export default {
  owner: 'duhongjun',
  repo: 'blog',
  todo_repo: 'todo',
  github_client_id: 'a0b1f18bb291ce5cf4a9',
  github_client_secret: '4187e2c827fa377c1159f10d40536c443ca8b0e2'
}



// WEBPACK FOOTER //
// ./src/config/config.js